export const setAutoLauncherOpenedLocalStorage = () => localStorage.setItem('chameleon-auto-launcher-open', true);
export const getAutoLauncherOpenedLocalStorage = () => JSON.parse(localStorage?.getItem('chameleon-auto-launcher-open') || null);
